import BaseBarGroup from "./private/BaseBarGroup.js";
import Bars from "./private/Bars.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function BarGroup(props) {
  return /*#__PURE__*/_jsx(BaseBarGroup, {
    ...props,
    BarsComponent: Bars
  });
}